import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { useScreen } from '@/hooks/useScreen';

interface CartItemDialogTotalProps {
  price: string;
}

export const CartItemDialogTotal = ({ price }: CartItemDialogTotalProps) => {
  const { sm } = useScreen();
  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'} mb={-4}>
      <Font variant={sm ? 'h3' : 'h4'} color="title" style={{ paddingBottom: 4 }}>
        <strong>{price}</strong>
      </Font>
    </Box>
  );
};
